import { useRef, useEffect } from 'react';

var intersectionObserver = function (onIntersect, observerOptions) {
    if ("IntersectionObserver" in window) {
        var observer_1 = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    onIntersect(entry.target);
                    observer_1.unobserve(entry.target);
                }
            });
        }, observerOptions);
        return observer_1;
    }
    else {
        var active_1 = false;
        var observedList_1 = [];
        var observer_2 = function () {
            if (active_1 === false) {
                active_1 = true;
                setTimeout(function () {
                    observedList_1.forEach(function (targetEle) {
                        var _a = targetEle.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
                        if ((top <= window.innerHeight && bottom >= 0) && getComputedStyle(targetEle).display !== "none") {
                            onIntersect(targetEle);
                            observedList_1 = observedList_1.filter(function (diffObserve) {
                                return diffObserve !== targetEle;
                            });
                            if (observedList_1.length === 0) {
                                document.removeEventListener("scroll", observer_2);
                                window.removeEventListener("resize", observer_2);
                                window.removeEventListener("orientationchange", observer_2);
                            }
                        }
                    });
                    active_1 = false;
                }, 200);
            }
        };
        document.addEventListener("scroll", observer_2);
        window.addEventListener("resize", observer_2);
        window.addEventListener("orientationchange", observer_2);
        return {
            observe: function (setElement) {
                observedList_1.push(setElement);
            }
        };
    }
};

var initalOptions = {
    root: null,
    rootMargin: "0px",
    thresholds: 0
};
var useIntersect = function (onIntersect, customOptions) {
    var targetRef = useRef();
    var observerOptions = customOptions || initalOptions;
    var observer;
    useEffect(function () {
        observer = intersectionObserver(onIntersect, observerOptions);
    });
    useEffect(function () {
        if (targetRef.current !== null) {
            observer.observe(targetRef.current);
        }
    }, [targetRef]);
    return targetRef;
};

export default useIntersect;
//# sourceMappingURL=index.es.js.map
